module.exports = __webpack_public_path__ + "static/img/i13.2251196.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i13.png
// module id = 5K2v
// module chunks = 0